import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { withConfig } from 'src/withConfig';

const setCellSize = (theme: EmotionTheme, mobileSize?: string, tabletSize?: string): SerializedStyles => {
    const mobile = mobileSize !== undefined && mobileSize.trim() !== ""
    ? `0 0 ${mobileSize}`
    : '1 1 auto';

    const tablet = tabletSize !== undefined && tabletSize.trim() !== ""
      ? `0 0 ${tabletSize}`
      : undefined;

    if (tablet === undefined || tablet === mobile) {
        return css`
            flex: ${mobile};
        `;
    }

    return css`
        flex: ${mobile};
        @media ${theme.star.mediaQuery.tablet} {
            flex: ${tablet};
        }
    `;
};

export type CellAlignmentType = 'left' | 'center' | 'right';

const setAlignment = (align?: CellAlignmentType): SerializedStyles => {
    if (align === 'center') {
        return css`
            justify-content: center;
            text-align: center;
        `;
    }
    if (align === 'right') {
        return css`
            justify-content: end;
            text-align: right;
        `;
    }

    return css`
        justify-content: start;
        text-align: left;
    `;
};

interface TableHeaderBoxType {
    align?: CellAlignmentType;
    isWide?: boolean;
    mobileSize?: string;
    tabletSize?: string;
}

export const TableHeaderBox = withConfig(theme => styled('span', { label: 'TableHeaderBox' })<TableHeaderBoxType>`
    ${({ mobileSize, tabletSize }): SerializedStyles => setCellSize(theme, mobileSize, tabletSize)}
    ${({ align }): SerializedStyles => setAlignment(align)}
    align-items: center;
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    line-height: ${theme.star.lineHeight[150]};
    padding: ${({ isWide }): string => isWide === true ? '4px 4px 4px 12px' : '4px 2px' };
`);
